module.exports = __webpack_public_path__ + "img/adult-boardroom-chairs-1181304.2ef61218.jpg";